import { Field, StatusBadge, formatDateTime } from "./ui";

const STATUSES = ["Pending", "Contacted", "Scheduled", "Completed", "Declined"];

export default function DemoRequestInfoSection({ current, saving, onStatusChange }) {
  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.03]">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400 dark:text-slate-500">Current status</p>
          <div className="mt-2">
            <StatusBadge status={current.status} testId="demo-detail-status" />
          </div>
        </div>
        <select
          value={current.status}
          onChange={(e) => onStatusChange(e.target.value)}
          disabled={saving}
          data-testid="demo-detail-status-select"
          className="rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-900 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/10 disabled:opacity-60 dark:border-white/15 dark:bg-white/5 dark:text-white"
        >
          {STATUSES.map((status) => <option key={status} value={status}>{status}</option>)}
        </select>
      </div>

      <div className="grid gap-5 sm:grid-cols-2" data-testid="demo-detail-fields">
        <Field label="Contact name" value={current.name} testId="demo-detail-name" />
        <Field label="Work email" value={current.email} testId="demo-detail-email" />
        <Field label="Company" value={current.company} testId="demo-detail-company" />
        <Field label="Role" value={current.role} testId="demo-detail-role" />
        <Field label="Company website" value={current.website} testId="demo-detail-website" />
        <Field label="Industry" value={current.industry} testId="demo-detail-industry" />
        <Field label="Other industry" value={current.other_industry} testId="demo-detail-other-industry" />
        <Field label="Submitted" value={formatDateTime(current.submitted_at)} testId="demo-detail-submitted" />
      </div>

      <div className="rounded-2xl border border-blue-100 bg-blue-50/70 p-4 text-sm text-blue-900 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300" data-testid="demo-tenant-note">
        This is a sales demo request. It does not create an Organization, User, credentials, or platform access.
      </div>
    </>
  );
}
